import React, { PureComponent } from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import { ConnectedEpisodeLandingPage } from './EpisodeLandingPage';
import { trackEvent } from '../../lib/Tracking';

type Match = {
  episodeId: string;
};

type Props = RouteComponentProps<Match>;

export class Episode extends PureComponent<Props> {
  componentDidMount() {
    trackEvent({ category: 'page-type', action: 'view', label: 'episode' });
  }

  render() {
    return (
      <Switch>
        <Route
          path={this.props.match.url}
          exact
          render={() => (
            <ConnectedEpisodeLandingPage
              data-qa="episode-landing-page"
              episodeId={this.props.match.params.episodeId}
            />
          )}
        />
      </Switch>
    );
  }
}
